import "../assets/css/HowItWorksSection.css";

const HowItWorksSection = () => {
  const steps = [
    { title: "Register as Partner", icon: "🧑‍🍳" },
    { title: "Add Menu / Products", icon: "📦" },
    { title: "Customer Places Order", icon: "🛍️" },
    { title: "Deliver", icon: "🚚" },
  ];

  return (
    <section className="all-main-section">
      <div className="all-main-section-content-wrapper">
        <h2 className="all-main-title" style={{ textAlign: "center" }}>
          How It <span>Works</span>
        </h2>
        <div className="flow-wrapper">
          {steps.map((step, index) => (
            <div className="step-card" key={index}>
              <div className="step-icon">
                <span className={step.icon === "🚚" ? "mirror-icon" : ""}>
                  {step.icon}
                </span>
              </div>

              <h3 className="step-title">{step.title}</h3>
              {index < steps.length - 1 && (
                <div className="step-connector">➔</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
